import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    const main = document.getElementById("main");
    if(main) main.scrollTop = -100;
  },
})



router.beforeEach(async (to, from, next) => {

  if (to.fullPath.includes("?CGMSISDN=")) {

    const queryKeys = Object.keys(to.query);

    // Find the key that starts with "click" (case-insensitive)
    const clickKey = queryKeys.find(key => key.toLowerCase().startsWith("ggclick"));
    console.log("clickKey: ", clickKey);
    // Use the found key to get the value
    const clickValue = clickKey ? to.query[clickKey] : null;
    console.log("clickValue: ", clickValue);
    return next({
      name: 'abrof.subscribe',
      params: {
        num: to.query.CGMSISDN,
        cgstatus: to.query.CGSTATUS,
        pubID: to.query.pubID,
        clickID: clickValue // Pass the value of the case-insensitive "click" key
      }
    })

  }

  const user = localStorage.getItem("user");

  
  if (to.meta.auth && user === null) {
    return next({ name: 'subscribe' });
  }

  if (to.meta.auth && user !== null) {
    return next();
  }

  if (to.meta.auth === false) {
    return next();
  }
  
  next()
})

export default router;
